import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68fefd66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "historic-production-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker_modal_component = _resolveComponent("date-picker-modal-component")!
  const _component_CTable = _resolveComponent("CTable")!
  const _component_CSpinner = _resolveComponent("CSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, [
      _createTextVNode(" Historyczna produkcja dla "),
      _createElementVNode("span", null, _toDisplayString(_ctx.pvInstallation.installation), 1)
    ]),
    _hoisted_1,
    _createVNode(_component_date_picker_modal_component, { onPickedDates: _ctx.fetchFromPickedDate }, null, 8, ["onPickedDates"]),
    _hoisted_2,
    _createElementVNode("h4", null, "Od " + _toDisplayString(_ctx.pvInstallation.startDate) + " Do: " + _toDisplayString(_ctx.pvInstallation.endDate), 1),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CTable, {
        striped: "",
        columns: _ctx.columns,
        items: _ctx.pvInstallation.data
      }, null, 8, ["columns", "items"])
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ], 64))
}